import {
    WorkerQueryFilters,
    WorkerStatus,
    WorkerTabKey,
} from '../../models/worker';

export type WorkerTabTone = 'error' | 'warning' | 'success' | 'info' | 'secondary';
export type WorkerTabCountKey = WorkerTabKey | 'nonEu' | 'rejectedBlocked';

export interface WorkerTabConfig {
    key: WorkerTabKey;
    label: string;
    description: string;
    tone: WorkerTabTone;
    filters?: Partial<WorkerQueryFilters>;
}

export const WORKER_TABS: readonly WorkerTabConfig[] = [
    {
        key: WorkerTabKey.INCOMPLETE,
        label: 'Incomplete',
        description: 'Missing required worker data',
        tone: 'error',
        filters: { status: WorkerStatus.INCOMPLETE },
    },
    {
        key: WorkerTabKey.AWAITING_DOCS,
        label: 'Awaiting Docs',
        description: 'Data complete - waiting on documents',
        tone: 'warning',
        filters: { status: WorkerStatus.PENDING_DOCUMENTS },
    },
    {
        key: WorkerTabKey.NEEDS_REVIEW,
        label: 'Needs Review',
        description: 'Ready - awaiting recruiter approval',
        tone: 'warning',
        filters: { status: WorkerStatus.PENDING_APPROVAL },
    },
    {
        key: WorkerTabKey.CANDIDATES,
        label: 'Candidates',
        description: 'Available and matchable',
        tone: 'success',
        filters: { status: WorkerStatus.CANDIDATE },
    },
    {
        key: WorkerTabKey.PLACED,
        label: 'Placed',
        description: 'Currently placed',
        tone: 'info',
        filters: { status: WorkerStatus.PLACED },
    },
    {
        key: WorkerTabKey.RESERVE_POOL,
        label: 'Reserve Pool',
        description: 'Kept available for future opportunities',
        tone: 'secondary',
        filters: { status: WorkerStatus.RESERVE_POOL },
    },
    {
        key: WorkerTabKey.ALL,
        label: 'All',
        description: 'Everything you can access',
        tone: 'secondary',
        filters: {},
    },
];
